import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import DeliveryOrder from "../../../containers/modules/sales/delivery-order";
import VisitSchedule from "../../../containers/modules/sales/visit-schedule";

export default function VisitScheduleRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="visit-schedule"
      index
      element={
        <AccessControl
          name={"Visit Schedule Show"}
          auth={authUser}
          component={() => <VisitSchedule />}
        />
      }
    />
  );
}
